/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActivityFilter = "CurrentUser" | "CurrentUserOrInvited" | "Invited" | "%future added value";
export type SortDirection = "Ascending" | "Descending" | "%future added value";
export type SortType = "FullName" | "Status" | "%future added value";
export type AdminPanelBillingGroupsMembersQueryVariables = {
    orgRelayId: string;
    sortType: SortType;
    sortDirection: SortDirection;
    searchQuery?: string | null | undefined;
    pageToken?: string | null | undefined;
    fetchNext?: boolean | null | undefined;
    limit?: number | null | undefined;
    teamId?: string | null | undefined;
    billingGroupId?: string | null | undefined;
    activityFilter?: ActivityFilter | null | undefined;
};
export type AdminPanelBillingGroupsMembersQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"AdminPanelBillingGroupsMembers_viewer">;
    };
    readonly org: {
        readonly id?: string | undefined;
        readonly " $fragmentRefs": FragmentRefs<"AdminPanelBillingGroupsMembers_org">;
    } | null;
};
export type AdminPanelBillingGroupsMembersQuery = {
    readonly response: AdminPanelBillingGroupsMembersQueryResponse;
    readonly variables: AdminPanelBillingGroupsMembersQueryVariables;
};



/*
query AdminPanelBillingGroupsMembersQuery(
  $orgRelayId: ID!
  $sortType: SortType!
  $sortDirection: SortDirection!
  $searchQuery: String
  $pageToken: String
  $fetchNext: Boolean
  $limit: Int
  $teamId: String
  $billingGroupId: String
  $activityFilter: ActivityFilter
) {
  viewer {
    ...AdminPanelBillingGroupsMembers_viewer
    id
  }
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      id
      ...AdminPanelBillingGroupsMembers_org_5Y1qI
    }
    id
  }
}

fragment AdminPanelBillingGroupsMembers_org_5Y1qI on Org {
  ...OrgInvite_org
  ...AdminSelect_org_5Y1qI
  id
  orgPersonListPaginatedErrorable(sortType: $sortType, sortDirection: $sortDirection, searchQuery: $searchQuery, pageToken: $pageToken, fetchNext: $fetchNext, limit: $limit, teamId: $teamId, billingGroupId: $billingGroupId, activityFilter: $activityFilter) {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on OrgPersonListPaginated {
      inputQuery
      nextPersonId
      previousPersonId
      searchPersons {
        person {
          primaryCalendarId
          userId
          personId
          signUpMillis
          isYou
          primaryBillingGroupIdErrorable {
            __typename
            ... on PrimaryBillingGroupId {
              primaryBillingGroupId
            }
            ... on GraphEntityError {
              message
              statusCode
            }
          }
          profile {
            givenName
            familyName
            externalImageUrl
          }
          id
        }
        status
      }
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        id
        targetCalendarId
        targetProfile {
          givenName
          familyName
          externalImageUrl
        }
        resolution
        numberOfSharedMeetings
        numberOfOrganizedMeetings
        inviteReason
        totalScore
      }
    }
  }
  teamsForOrg {
    __typename
    ... on TeamList {
      list {
        teamId
        teamName
        id
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        createdAtMillis
        invitePolicy
        type
        dsyncConfigured {
          __typename
          ... on DsyncConfigured {
            isDsyncConfigured
          }
          ... on GraphEntityError {
            statusCode
            message
          }
        }
        personListPaginatedErrorable {
          __typename
          __isOrgPersonListPaginatedErrorable: __typename
          ... on GraphEntityError {
            message
          }
          ... on OrgPersonListPaginated {
            count
          }
        }
        manualMembers {
          __typename
          ... on BillingGroupManualMemberList {
            list {
              externalUserId
              calendarId
              userId
              personId
              orgPerson {
                __typename
                ... on OrgPerson {
                  userId
                  personId
                  primaryCalendarId
                  isYou
                  signUpMillis
                  profile {
                    givenName
                    familyName
                  }
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
                ... on Node {
                  __isNode: __typename
                  id
                }
              }
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        adminOrgPersons {
          __typename
          ... on OrgPersonList {
            list {
              userId
              personId
              primaryCalendarId
              isYou
              signUpMillis
              profile {
                givenName
                familyName
              }
              id
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        subscription {
          __typename
          ... on SubscriptionDetails {
            subscription {
              id
              productType
              seatCount
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment AdminPanelBillingGroupsMembers_viewer on Viewer {
  ...OrgInvite_viewer
}

fragment AdminSelect_org_5Y1qI on Org {
  id
  orgPersonListPaginatedErrorable(sortType: $sortType, sortDirection: $sortDirection, searchQuery: $searchQuery, pageToken: $pageToken, fetchNext: $fetchNext, limit: $limit, teamId: $teamId, billingGroupId: $billingGroupId, activityFilter: $activityFilter) {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on OrgPersonListPaginated {
      inputQuery
      nextPersonId
      previousPersonId
      searchPersons {
        person {
          primaryCalendarId
          userId
          personId
          signUpMillis
          isYou
          primaryBillingGroupIdErrorable {
            __typename
            ... on PrimaryBillingGroupId {
              primaryBillingGroupId
            }
            ... on GraphEntityError {
              message
              statusCode
            }
          }
          profile {
            givenName
            familyName
            externalImageUrl
          }
          id
        }
        status
      }
    }
  }
  billingGroups {
    __typename
    ... on BillingGroupList {
      list {
        id
        name
        createdAtMillis
        invitePolicy
        manualMembers {
          __typename
          ... on BillingGroupManualMemberList {
            list {
              externalUserId
              calendarId
              userId
              personId
              orgPerson {
                __typename
                ... on OrgPerson {
                  userId
                  personId
                  primaryCalendarId
                  isYou
                  signUpMillis
                  profile {
                    givenName
                    familyName
                  }
                }
                ... on GraphEntityError {
                  message
                  statusCode
                }
                ... on Node {
                  __isNode: __typename
                  id
                }
              }
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
        adminOrgPersons {
          __typename
          ... on OrgPersonList {
            list {
              userId
              personId
              primaryCalendarId
              isYou
              signUpMillis
              profile {
                givenName
                familyName
              }
              id
            }
          }
          ... on GraphEntityError {
            message
            statusCode
          }
        }
      }
    }
    ... on GraphEntityError {
      message
      statusCode
    }
  }
}

fragment CopyPersonalInviteLinkBtn_org on Org {
  id
  experiments
}

fragment CopyPersonalInviteLinkBtn_user on User {
  id
}

fragment InviteButton_org on Org {
  id
}

fragment InviteCard_org on Org {
  ...InviteButton_org
}

fragment OrgInvite_org on Org {
  id
  ...InviteCard_org
  ...CopyPersonalInviteLinkBtn_org
  personCorpusErrorable {
    __typename
    ... on GraphEntityError {
      message
    }
    ... on PersonList {
      list {
        primaryEmail
        emails
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
        id
      }
    }
  }
  suggestedInvites(first: 1000000) {
    edges {
      node {
        id
        targetCalendarId
        targetProfile {
          givenName
          familyName
          externalImageUrl
        }
        resolution
        numberOfSharedMeetings
        numberOfOrganizedMeetings
        inviteReason
        totalScore
      }
    }
  }
  pendingInvites(first: 1000000) {
    edges {
      node {
        id
        targetCalendarId
        lastSentTime
        targetProfile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  }
}

fragment OrgInvite_viewer on Viewer {
  user {
    ...CopyPersonalInviteLinkBtn_user
    id
  }
  personQueryResultErrorable(query: "", orgRelayId: "") {
    __typename
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on PersonQueryResult {
      query
      persons {
        id
        primaryEmail
        emails
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
        isUser
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "activityFilter"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "billingGroupId"
    } as any, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fetchNext"
    } as any, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    } as any, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageToken"
    } as any, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchQuery"
    } as any, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortDirection"
    } as any, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortType"
    } as any, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "teamId"
    } as any, v10 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v12 = [
        {
            "kind": "Variable",
            "name": "activityFilter",
            "variableName": "activityFilter"
        } as any,
        {
            "kind": "Variable",
            "name": "billingGroupId",
            "variableName": "billingGroupId"
        } as any,
        {
            "kind": "Variable",
            "name": "fetchNext",
            "variableName": "fetchNext"
        } as any,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        } as any,
        {
            "kind": "Variable",
            "name": "pageToken",
            "variableName": "pageToken"
        } as any,
        {
            "kind": "Variable",
            "name": "searchQuery",
            "variableName": "searchQuery"
        } as any,
        {
            "kind": "Variable",
            "name": "sortDirection",
            "variableName": "sortDirection"
        } as any,
        {
            "kind": "Variable",
            "name": "sortType",
            "variableName": "sortType"
        } as any,
        {
            "kind": "Variable",
            "name": "teamId",
            "variableName": "teamId"
        } as any
    ], v13 = [
        (v11 /*: any*/)
    ], v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v17 = {
        "kind": "InlineFragment",
        "selections": [
            (v15 /*: any*/),
            (v16 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v18 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v19 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "emails",
        "storageKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "givenName",
        "storageKey": null
    } as any, v21 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "familyName",
        "storageKey": null
    } as any, v22 = [
        (v20 /*: any*/),
        (v21 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalImageUrl",
            "storageKey": null
        } as any
    ], v23 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": (v22 /*: any*/),
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUser",
        "storageKey": null
    } as any, v26 = {
        "kind": "InlineFragment",
        "selections": [
            (v16 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v27 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000000
        } as any
    ], v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "targetCalendarId",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "targetProfile",
        "plural": false,
        "selections": (v22 /*: any*/),
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v31 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v32 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v33 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "signUpMillis",
        "storageKey": null
    } as any, v34 = {
        "kind": "InlineFragment",
        "selections": [
            (v16 /*: any*/),
            (v15 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v35 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            (v20 /*: any*/),
            (v21 /*: any*/)
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v4 /*: any*/),
                (v5 /*: any*/),
                (v6 /*: any*/),
                (v7 /*: any*/),
                (v8 /*: any*/),
                (v9 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "AdminPanelBillingGroupsMembersQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AdminPanelBillingGroupsMembers_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v10 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v11 /*: any*/),
                                {
                                    "args": (v12 /*: any*/),
                                    "kind": "FragmentSpread",
                                    "name": "AdminPanelBillingGroupsMembers_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v4 /*: any*/),
                (v8 /*: any*/),
                (v7 /*: any*/),
                (v6 /*: any*/),
                (v5 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/),
                (v9 /*: any*/),
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "AdminPanelBillingGroupsMembersQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": (v13 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orgRelayId",
                                    "value": ""
                                },
                                {
                                    "kind": "Literal",
                                    "name": "query",
                                    "value": ""
                                }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "personQueryResultErrorable",
                            "plural": false,
                            "selections": [
                                (v14 /*: any*/),
                                (v17 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "query",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Person",
                                            "kind": "LinkedField",
                                            "name": "persons",
                                            "plural": true,
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v18 /*: any*/),
                                                (v19 /*: any*/),
                                                (v23 /*: any*/),
                                                (v24 /*: any*/),
                                                (v25 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "PersonQueryResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": "personQueryResultErrorable(orgRelayId:\"\",query:\"\")"
                        },
                        (v11 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v10 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v14 /*: any*/),
                        (v11 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "experiments",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "personCorpusErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/),
                                        (v26 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Person",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v18 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v23 /*: any*/),
                                                        (v24 /*: any*/),
                                                        (v25 /*: any*/),
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "PersonList",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v27 /*: any*/),
                                    "concreteType": "SuggestedOrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "suggestedInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SuggestedOrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedOrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "resolution",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "numberOfSharedMeetings",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "numberOfOrganizedMeetings",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "inviteReason",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "totalScore",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "suggestedInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v27 /*: any*/),
                                    "concreteType": "OrgInviteConnection",
                                    "kind": "LinkedField",
                                    "name": "pendingInvites",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgInviteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "OrgInvite",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        (v28 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "lastSentTime",
                                                            "storageKey": null
                                                        },
                                                        (v29 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "pendingInvites(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": (v12 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgPersonListPaginatedErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/),
                                        (v26 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "inputQuery",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "nextPersonId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "previousPersonId",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SearchPerson",
                                                    "kind": "LinkedField",
                                                    "name": "searchPersons",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgPerson",
                                                            "kind": "LinkedField",
                                                            "name": "person",
                                                            "plural": false,
                                                            "selections": [
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v32 /*: any*/),
                                                                (v33 /*: any*/),
                                                                (v24 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "primaryBillingGroupIdErrorable",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v14 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "primaryBillingGroupId",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "PrimaryBillingGroupId",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v34 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v23 /*: any*/),
                                                                (v11 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "status",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgPersonListPaginated",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "billingGroups",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "BillingGroup",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "createdAtMillis",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "invitePolicy",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "manualMembers",
                                                            "plural": false,
                                                            "selections": [
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "BillingGroupManualMember",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUserId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "calendarId",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v31 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "orgPerson",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v14 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v31 /*: any*/),
                                                                                                (v32 /*: any*/),
                                                                                                (v30 /*: any*/),
                                                                                                (v24 /*: any*/),
                                                                                                (v33 /*: any*/),
                                                                                                (v35 /*: any*/)
                                                                                            ],
                                                                                            "type": "OrgPerson",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v34 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": (v13 /*: any*/),
                                                                                            "type": "Node",
                                                                                            "abstractKey": "__isNode"
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "BillingGroupManualMemberList",
                                                                    "abstractKey": null
                                                                },
                                                                (v34 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "adminOrgPersons",
                                                            "plural": false,
                                                            "selections": [
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "OrgPerson",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                (v31 /*: any*/),
                                                                                (v32 /*: any*/),
                                                                                (v30 /*: any*/),
                                                                                (v24 /*: any*/),
                                                                                (v33 /*: any*/),
                                                                                (v35 /*: any*/),
                                                                                (v11 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonList",
                                                                    "abstractKey": null
                                                                },
                                                                (v34 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "type",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "dsyncConfigured",
                                                            "plural": false,
                                                            "selections": [
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isDsyncConfigured",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "DsyncConfigured",
                                                                    "abstractKey": null
                                                                },
                                                                (v17 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "personListPaginatedErrorable",
                                                            "plural": false,
                                                            "selections": [
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "TypeDiscriminator",
                                                                    "abstractKey": "__isOrgPersonListPaginatedErrorable"
                                                                },
                                                                (v26 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "count",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "OrgPersonListPaginated",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "subscription",
                                                            "plural": false,
                                                            "selections": [
                                                                (v14 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "PaymentSubscription",
                                                                            "kind": "LinkedField",
                                                                            "name": "subscription",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v11 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "productType",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "seatCount",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "SubscriptionDetails",
                                                                    "abstractKey": null
                                                                },
                                                                (v34 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "BillingGroupList",
                                            "abstractKey": null
                                        },
                                        (v34 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "teamsForOrg",
                                    "plural": false,
                                    "selections": [
                                        (v14 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Team",
                                                    "kind": "LinkedField",
                                                    "name": "list",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamId",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "teamName",
                                                            "storageKey": null
                                                        },
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "TeamList",
                                            "abstractKey": null
                                        },
                                        (v17 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "cc8e8768192206ad8cb02270c00886cd",
            "id": null,
            "metadata": {},
            "name": "AdminPanelBillingGroupsMembersQuery",
            "operationKind": "query",
            "text": "query AdminPanelBillingGroupsMembersQuery(\n  $orgRelayId: ID!\n  $sortType: SortType!\n  $sortDirection: SortDirection!\n  $searchQuery: String\n  $pageToken: String\n  $fetchNext: Boolean\n  $limit: Int\n  $teamId: String\n  $billingGroupId: String\n  $activityFilter: ActivityFilter\n) {\n  viewer {\n    ...AdminPanelBillingGroupsMembers_viewer\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...AdminPanelBillingGroupsMembers_org_5Y1qI\n    }\n    id\n  }\n}\n\nfragment AdminPanelBillingGroupsMembers_org_5Y1qI on Org {\n  ...OrgInvite_org\n  ...AdminSelect_org_5Y1qI\n  id\n  orgPersonListPaginatedErrorable(sortType: $sortType, sortDirection: $sortDirection, searchQuery: $searchQuery, pageToken: $pageToken, fetchNext: $fetchNext, limit: $limit, teamId: $teamId, billingGroupId: $billingGroupId, activityFilter: $activityFilter) {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on OrgPersonListPaginated {\n      inputQuery\n      nextPersonId\n      previousPersonId\n      searchPersons {\n        person {\n          primaryCalendarId\n          userId\n          personId\n          signUpMillis\n          isYou\n          primaryBillingGroupIdErrorable {\n            __typename\n            ... on PrimaryBillingGroupId {\n              primaryBillingGroupId\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n          }\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          id\n        }\n        status\n      }\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        id\n        targetCalendarId\n        targetProfile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        resolution\n        numberOfSharedMeetings\n        numberOfOrganizedMeetings\n        inviteReason\n        totalScore\n      }\n    }\n  }\n  teamsForOrg {\n    __typename\n    ... on TeamList {\n      list {\n        teamId\n        teamName\n        id\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        createdAtMillis\n        invitePolicy\n        type\n        dsyncConfigured {\n          __typename\n          ... on DsyncConfigured {\n            isDsyncConfigured\n          }\n          ... on GraphEntityError {\n            statusCode\n            message\n          }\n        }\n        personListPaginatedErrorable {\n          __typename\n          __isOrgPersonListPaginatedErrorable: __typename\n          ... on GraphEntityError {\n            message\n          }\n          ... on OrgPersonListPaginated {\n            count\n          }\n        }\n        manualMembers {\n          __typename\n          ... on BillingGroupManualMemberList {\n            list {\n              externalUserId\n              calendarId\n              userId\n              personId\n              orgPerson {\n                __typename\n                ... on OrgPerson {\n                  userId\n                  personId\n                  primaryCalendarId\n                  isYou\n                  signUpMillis\n                  profile {\n                    givenName\n                    familyName\n                  }\n                }\n                ... on GraphEntityError {\n                  message\n                  statusCode\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        adminOrgPersons {\n          __typename\n          ... on OrgPersonList {\n            list {\n              userId\n              personId\n              primaryCalendarId\n              isYou\n              signUpMillis\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n              seatCount\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment AdminPanelBillingGroupsMembers_viewer on Viewer {\n  ...OrgInvite_viewer\n}\n\nfragment AdminSelect_org_5Y1qI on Org {\n  id\n  orgPersonListPaginatedErrorable(sortType: $sortType, sortDirection: $sortDirection, searchQuery: $searchQuery, pageToken: $pageToken, fetchNext: $fetchNext, limit: $limit, teamId: $teamId, billingGroupId: $billingGroupId, activityFilter: $activityFilter) {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on OrgPersonListPaginated {\n      inputQuery\n      nextPersonId\n      previousPersonId\n      searchPersons {\n        person {\n          primaryCalendarId\n          userId\n          personId\n          signUpMillis\n          isYou\n          primaryBillingGroupIdErrorable {\n            __typename\n            ... on PrimaryBillingGroupId {\n              primaryBillingGroupId\n            }\n            ... on GraphEntityError {\n              message\n              statusCode\n            }\n          }\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n          id\n        }\n        status\n      }\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        createdAtMillis\n        invitePolicy\n        manualMembers {\n          __typename\n          ... on BillingGroupManualMemberList {\n            list {\n              externalUserId\n              calendarId\n              userId\n              personId\n              orgPerson {\n                __typename\n                ... on OrgPerson {\n                  userId\n                  personId\n                  primaryCalendarId\n                  isYou\n                  signUpMillis\n                  profile {\n                    givenName\n                    familyName\n                  }\n                }\n                ... on GraphEntityError {\n                  message\n                  statusCode\n                }\n                ... on Node {\n                  __isNode: __typename\n                  id\n                }\n              }\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n        adminOrgPersons {\n          __typename\n          ... on OrgPersonList {\n            list {\n              userId\n              personId\n              primaryCalendarId\n              isYou\n              signUpMillis\n              profile {\n                givenName\n                familyName\n              }\n              id\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n}\n\nfragment CopyPersonalInviteLinkBtn_org on Org {\n  id\n  experiments\n}\n\nfragment CopyPersonalInviteLinkBtn_user on User {\n  id\n}\n\nfragment InviteButton_org on Org {\n  id\n}\n\nfragment InviteCard_org on Org {\n  ...InviteButton_org\n}\n\nfragment OrgInvite_org on Org {\n  id\n  ...InviteCard_org\n  ...CopyPersonalInviteLinkBtn_org\n  personCorpusErrorable {\n    __typename\n    ... on GraphEntityError {\n      message\n    }\n    ... on PersonList {\n      list {\n        primaryEmail\n        emails\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n        id\n      }\n    }\n  }\n  suggestedInvites(first: 1000000) {\n    edges {\n      node {\n        id\n        targetCalendarId\n        targetProfile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        resolution\n        numberOfSharedMeetings\n        numberOfOrganizedMeetings\n        inviteReason\n        totalScore\n      }\n    }\n  }\n  pendingInvites(first: 1000000) {\n    edges {\n      node {\n        id\n        targetCalendarId\n        lastSentTime\n        targetProfile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n      }\n    }\n  }\n}\n\nfragment OrgInvite_viewer on Viewer {\n  user {\n    ...CopyPersonalInviteLinkBtn_user\n    id\n  }\n  personQueryResultErrorable(query: \"\", orgRelayId: \"\") {\n    __typename\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on PersonQueryResult {\n      query\n      persons {\n        id\n        primaryEmail\n        emails\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n        isUser\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '844ec428db4fde3d69227275f76e51fa';
export default node;
